export default {
  computed: {
    buttons () {
      let btns = this.$store.state.buttons.slice()
      return btns
    }
  },
  methods: {
    async sendMessage ({message, textShowed}) {
      if (textShowed == null) {
        textShowed = message
      }
      await this.$store.dispatch('sendMessage', {message, textShowed: '✓ ' + textShowed})
    },
    yesNoAnswer (message, answer) {
      this.normalMessage(window.civiiConf.options['yes/no-automatic'].question, 'left')
      this.normalAnswer(message, answer)
    },
    normalAnswer (message, answer) {
      this.normalMessage(message, 'right')
      this.normalMessage(answer, 'left')
      this.$store.commit('setButtons', [])
    },
    normalMessage (message, side) {
      this.addMessage({
        type: 'Normal',
        side,
        messages: [
          {
            text: message
          }
        ]
      })
    },
    addMessage (message) {
      this.$store.commit('addMessage', message)
    }
  },
  render (h) {
    let that = this
    if (Array.isArray(this.buttons) && this.buttons.length > 0) {
      let optionsLabel = window.civiiConf.optionsLabel
      if (optionsLabel == null) optionsLabel = 'Opciones'
      return h('div', [
        h('div', {class: 'options-title'}, optionsLabel + ':'),
        h('div', {class: 'options-container'}, [
          h('div', {class: 'options'},
            this.buttons.map(function (button, index) {
              let message = null
              let textShowed = null
              if (!Array.isArray(button) && typeof button === 'object' && button !== null) {
                message = button.message
                textShowed = button.text
              } else if (typeof button === 'string') {
                message = button
              }
              return h('div',
                {
                  key: 'option' + index,
                  class: 'option-button-normal',
                  on: {click () {
                    that.sendMessage({message, textShowed})
                  }}
                }, textShowed != null ? textShowed : message)
            })
          )
        ])
      ])
    } else if (typeof this.buttons === 'object' && this.buttons !== null) {
      if (this.buttons.type === 'yes/no') {
        return h('div', {class: 'option-buttons'}, [
          h('button', {
            class: 'option-button-yes',
            on: {click () {
              that.sendMessage({message: 'true'})
            }}
          }, 'Sí'),
          h('button', {
            class: 'option-button-no',
            on: {click () {
              that.sendMessage({message: 'false'})
            }}
          }, 'No')
        ])
      } else if (this.buttons.type === 'yes/no-automatic') {
        return h('div', [
          h('div', {class: 'options-message'}, [h('div', window.civiiConf.options[that.buttons.type].question)]),
          h('div', {class: 'option-buttons'}, [
            h('button', {
              class: 'option-button-yes',
              on: {click () {
                that.yesNoAnswer('Sí', window.civiiConf.options[that.buttons.type].yesAnswer)
              }}
            }, 'Sí'),
            h('button', {
              class: 'option-button-no',
              on: {click () {
                that.yesNoAnswer('No', window.civiiConf.options[that.buttons.type].NoAnswer)
              }}
            }, 'No')
          ])
        ])
      }
    }
    return h('div', '')
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/Options/Options.js